module.exports = __webpack_public_path__ + "img/success.c9cb1265.png";